import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider, GithubAuthProvider, FacebookAuthProvider, signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import app from '../../firebase.init';
import { UserContext } from '../../App';

const auth = getAuth(app);

const Login = () => {
    const navigate = useNavigate();
    let user = {};
    let {setExist, setUser} = useContext(UserContext);
    let googleProvider = new GoogleAuthProvider();
    let githubProvider = new GithubAuthProvider();
    let facebookProvider = new FacebookAuthProvider();
    



    let googleLogIn = () => {
        signInWithPopup(auth, googleProvider)
        .then(result =>{
            user = result.user;
            setUser(user); 
            setExist(true);   
            navigate('/user');
        })
        .catch(err => {
            let errCode = err.code;
            let errMsg = err.message;
            console.error(errMsg, errCode);
        })
    }

    let githubLogIn = () => {
        signInWithPopup(auth, githubProvider)
        .then(result =>{
            user = result.user;
            setUser(user); 
            setExist(true);   
            navigate('/user');
        })
        .catch(err => {
            let errCode = err.code;
            let errMsg = err.message;
            console.error(errMsg, errCode);
        })
    }
    let facebookLogIn = () => {
        signInWithPopup(auth, facebookProvider)
        .then(result =>{
            user = result.user;
            setUser(user); 
            setExist(true);   
            navigate('/user');
        })
        .catch(err => {
            let errCode = err.code;
            let errMsg = err.message;
            console.error(errMsg, errCode);
        })
    }



    let submitForm = (e) => {
        e.preventDefault();
        console.log(e.target.email);
        let email = e.target.email.value;
        let password = e.target.password.value;
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                setUser(user);
                setExist(true);
                e.target.reset();
                navigate('/user');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(errorCode, errorMessage);
                e.target.reset();
            });
    }

    let forgotPassword = (e) => {
        e.preventDefault();
        let email = e.nativeEvent.path[2].email.value;
        sendPasswordResetEmail(auth, email)
            .then(() => {
                e.nativeEvent.path[2].reset();
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(errorCode, errorMessage);
            });
    }
    return (
        <div className='max-w-xl px-4 mx-auto my-20'>
            <h1 className='text-3xl mt-5 text-success '>Please Login</h1>

            <form className='text-left my-10' onSubmit ={submitForm} >
                
                <h1 className='text-xl text-primary'>Email</h1>
                <input type="text" name='email' placeholder="Email" className="input input-bordered input-secondary w-full my-5" />

                <h1 className='text-xl text-primary'>Password</h1>
                <input type="password" name='password' placeholder="Password" className="input input-bordered input-secondary w-full my-5" />
                <div className='mx-auto flex justify-between'>
                    <button type='submit' className='btn btn-success mt-5 px-10'>Log In</button>
                    <Link to='/register'>
                    <button className='btn btn-primary mt-5 px-10'>New User?</button>
                    </Link>
                </div>
                <Link className='text-blue-500 underline'
                onClick={forgotPassword}
                >
                    <h1 className='text-xs mt-5'>Forgot password?</h1>
                </Link>
            </form>
            <div className='flex justify-evenly'>
                <button onClick={googleLogIn}><i className="fa-brands fa-google text-xl"></i></button>
                <button onClick={githubLogIn}><i className="fa-brands fa-github text-xl"></i></button>
                <button onClick={facebookLogIn}><i className="fa-brands fa-facebook text-xl"></i></button>
            </div>
        </div>
    );
};

export default Login;